document.addEventListener("DOMContentLoaded", function(event) {
  let el = document.querySelector('.mobile-opener__holder');

  let link = document.querySelector('.no-click');
  link.onclick = function(e) {
    e.preventDefault();
  }

  el.onclick = function() {
    el.parentElement.classList.toggle('active');
    document.body.classList.toggle('disable-body')
  }

  const headers = document.getElementsByClassName("mobile-menu__second-level__link"),
        contents = document.getElementsByClassName("mobile-menu__third-level")
  for (let i = 0; i < headers.length; i++) {
    headers[i].addEventListener("click", () => {

        for (let j = 0; j < contents.length; j++) {
            if (i == j) {
                contents[j].parentElement.classList.toggle("content-transition");

            } else {
                contents[j].parentElement.classList.remove("content-transition");
            }
        }

    });
  }
})


document.addEventListener("DOMContentLoaded", function() {
  let mobileMenu = document.querySelector(".mobile-menu");
  let menuItems = mobileMenu.querySelectorAll(".mobile-menu__item");

  menuItems[0].style.padding = "0";

  menuItems.forEach( item => {
    if( item.innerHTML.trim() == ""){
      item.style.display = "none";
    }
  })
});